import { useEffect, useState } from 'react';
import playerService from '../../../helpers/bitmovinPlayer';
import { isPlayerAlive } from '../../../helpers/playerGuards';

// TODO: Move to config/constants file
const TIMESHIFT_ON_PLAYER_READY = 5;

const useLiveProgram = (): boolean => {
    const player = playerService.player;
    const [isProgramLive, setIsProgramLive] = useState(false);

    useEffect(() => {
        return subscribeToLiveStatus(setIsProgramLive);
    }, [player]);

    return isProgramLive;
};

/**
 * Polls the Bitmovin player instance to determine if the current playback is at the live edge.
 *
 * @param cb - Callback invoked with a boolean indicating whether the player is currently at the live edge.
 * @returns A cleanup function that will stop the polling when called, or `undefined` if no player was available.
 */
export const subscribeToLiveStatus = (cb: (isLive: boolean) => void) => {
    let interval: NodeJS.Timeout | undefined;

    const stopPolling = () => {
        if (interval !== undefined) {
            clearInterval(interval);
            interval = undefined;
        }
    };

    /**
     * Checking whether stream is at the live edge and calling the provided callback with `true` if it is and `false`
     * otherwise.
     */
    const checkLiveStatus = () => {
        // Always read the current player — start-over / channel switch destroys the old
        // instance while playerService may still hold its reference for a short time.
        const player = playerService.getPlayer();

        if (!player || !isPlayerAlive(player)) {
            stopPolling();
            cb(false);
            return;
        }

        if (player.isPaused()) {
            cb(false);
            return;
        }

        cb(Math.abs(player.getTimeShift()) - TIMESHIFT_ON_PLAYER_READY < 5);
    };

    const player = playerService.getPlayer();
    if (!player || !isPlayerAlive(player)) return;

    checkLiveStatus();
    interval = setInterval(checkLiveStatus, 300);

    return stopPolling;
};

export default useLiveProgram;
